export default new URL("../images/contact.jpg", import.meta.url).href;